export const validateDollars = (value: string) => {
	const result = /^-?\d*\.?\d?\d?/.exec(value)
	return result ? result[0] : ''
}

// todo these turned out to be less useful than i'd hoped
// perhaps they're not worth keeping, up to you.
export const toDollars = (totalValue: number) => {
	const cents = totalValue % 100
	const dollars = (totalValue - cents) / 100
	return dollarsAndCents(dollars, cents)
}

export const fromDollars = (dollars: string): number => {
	const parts = dollars.split(".")
	return Number.parseInt(parts[0]) * 100 + Number.parseInt(parts[1] || "0")
}

const dollarsAndCents = (dollars: number, cents: number) => dollars.toString() + (cents ? "." + renderJustCents(cents) : "")
const renderJustCents = (cents: number) => 0 < cents && cents < 10 ? "0" + cents : (cents % 100).toString()



// WEBPACK FOOTER //
// ./src/lib/price-utilities.ts